import { gql } from 'graphql-tag';
import {PAGINATION, GET_QUOTATION, QUOTATION_DETAIL} from './Fragments';

export const GET_QUOTATION_LISTS = gql`
    query GetQuotations($page: Int, $limit: Int) {
        quotations(limit:$limit, page:$page){
            ...Pagination
            data {
                ...QuotationFields
            }
        }
    }
    ${GET_QUOTATION},
    ${PAGINATION},
`;

export const SEARCH_QUOTATION_LISTS = gql`
    query SearchQuotation($page: Int, $limit: Int, $filter: String, $types: String, $export_date_from: String, $export_date_to: String, $locale: String) {
        search_quotations(limit:$limit, page:$page, filter:$filter, types: $types, export_date_from: $export_date_from, export_date_to: $export_date_to, locale: $locale){
            ...Pagination
            data {
                ...QuotationFields
            }
        }
    }
    ${GET_QUOTATION},
    ${PAGINATION},
`;

export const GET_QUOTATION_DETAIL = gql`
    query GetQuotationDetail($uuid: String) {
        quotation_detail(uuid:$uuid){
            ...QuotationDetailFields
        }
    }
    ${QUOTATION_DETAIL},
`;

export default { GET_QUOTATION_LISTS, GET_QUOTATION_DETAIL };
